import AbstractPopup from "./AbstractPopup";
import Button from "../../views/components/Button";
import ViewManager from "../../utils/ViewManager";
import { DefaultLayers } from "../../utils/Layers";
import PointerEvents from "../../const/PointerEvents";
import TextField from "../../views/components/TextField";
import Locale from "../../utils/Locale";
import { MoneyField } from '../../views/MoneyField';
import BetModel from '../../model/BetModel';
import BuyFeatureModel from '../../model/BuyFeatureModel';
import CommandManager from '../../commands/CommandManager';
import { Commands } from '../../commands/CommandEnum';
import { VendorCommandsEnum } from '../../../../src/commands/VendorCommandsEnum';
import SceneView from '../../views/SceneView';
import SoundController from '../../utils/SoundController';
import SoundVars from '../../const/SoundVars';
import ConfigManager from '../../managers/ConfigManager';
import IBuyFeatureConfig from '../../managers/contracts/configurations/IBuyFeatureConfig';
import IBetConfig from '../../managers/contracts/configurations/IBetConfig';
import KeyboardManager, { Key } from '../../utils/KeyboardManager';
import { ConfigurationTypes } from '../../const/ConfigurationTypes';

export default class BuyFeaturePopup extends AbstractPopup {
    public title: TextField;
    public text: TextField;
    public closeBtn: Button;
    public playBtn: Button;
    public betField: MoneyField;
    public totalPriceField: MoneyField;
    public animScene: SceneView;
    public plusBtn: Button;
    public minusBtn: Button;

    constructor() {
        super();
        this.layer = ViewManager.getLayer(DefaultLayers.Popups);
    }

    public show(callback?: Function) {
        KeyboardManager.disable()
        this.hidden = false;
        this.scene = this.layer.setScene('futurebuy');
        // prevent execute behind buttons events !
        this.scene.interactive = true;
        // this.animScene = ViewManager.getLayer("BuyFeaturePopup").setScene("open");
        this.closeBtn = this.scene.buttons.get("cancel");
        this.playBtn = this.scene.buttons.get("ok");
        this.betField = this.scene.sceneMoneyFields.get('amount') as MoneyField;
        this.totalPriceField = this.scene.sceneMoneyFields.get('total_amount') as MoneyField;
        this.plusBtn = this.scene.buttons.get("plus");
        this.minusBtn = this.scene.buttons.get("minus");

        this.setBetOptions();
        this.setBet();
        this.setTotalPrice();
        this.setInteractionOnPlus();
        this.setInteractionOnMinus();
        this.setInteractionOnPlay();
        this.setInteractionOnClose(callback);
    }
    protected setInteractionOnPlus = () => {
        this.plusBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            this.incrementBet();
            this.disableBetOptions();
        })
    }
    protected setInteractionOnMinus = () => {
        this.minusBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            this.decrementBet();
            this.disableBetOptions();
        })
    }
    protected setInteractionOnPlay = () => {
        this.playBtn.on(PointerEvents.DOWN, () => {
            let config = ConfigManager.getConfig(ConfigurationTypes.BUY_FEATURE);
            BuyFeatureModel.hasBuyFeatureIsTriggered = true;
            BetModel.balance -= config.betMultiplier * BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];
            CommandManager.execute(VendorCommandsEnum.FEATURE_BYE_SPIN);
            this.hide()
        })
    }
    protected setInteractionOnClose = (callback?: Function) => {
        this.closeBtn.on(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            if (callback) {
                callback();
            }
            this.hide();
        });
    }
    protected setBetOptions = () => {
        /*
        slice all valid bets to bets witch we displayed on the Bet Settings example case 12
        */
        let bfConfig = ConfigManager.getConfig(ConfigurationTypes.BUY_FEATURE);
        let betConfig = ConfigManager.getConfig(ConfigurationTypes.BET);

        if (bfConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = bfConfig.getBetOptions();
        } else if (betConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = betConfig.getBetOptions();
        } else {
            BuyFeatureModel.validBets = [...BetModel.creditValues];
        }

        BuyFeatureModel.currentBetIndex = BuyFeatureModel.validBets.indexOf(BetModel.totalBet);
    }
    protected disableBetOptions = (): void => {
        if (BuyFeatureModel.currentBetIndex >= (BuyFeatureModel.validBets.length - 1)) {
            this.plusBtn.setEnabled(false);
        } else if (BuyFeatureModel.currentBetIndex === 0) {
            this.minusBtn.setEnabled(false);
        } else {
            this.plusBtn.setEnabled(true);
            this.minusBtn.setEnabled(true);
        }

    }
    protected betSync = () => {
        CommandManager.execute(Commands.SET_BET, BetModel.creditValues.indexOf(BuyFeatureModel.getBet()))
    }
    protected setTotalPrice = () => {
        let config = ConfigManager.getConfig(ConfigurationTypes.BUY_FEATURE);
        let price = this.betField.value * config.betMultiplier;
        this.totalPriceField.value = price;
        this.checkBalanceEnoughForBuy(price);
    }
    protected setBet = () => {
        let bet = BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];
        if (bet) {
            this.betField.value = bet;
        } else {
            this.betField.value = null;
        }
    }

    public hide() {
        super.hide();
        KeyboardManager.enable();
    }

    protected checkBalanceEnoughForBuy = (price: number) => {
        if (BetModel.balance - price >= 0) {
            this.playBtn.setEnabled(true)
        } else {
            this.playBtn.setEnabled(false)
        }
    }

    protected incrementBet = () => {
        if (BuyFeatureModel.currentBetIndex < (BuyFeatureModel.validBets.length - 1)) {
            BuyFeatureModel.currentBetIndex += 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }
    protected decrementBet = () => {
        if (BuyFeatureModel.currentBetIndex > 0) {
            BuyFeatureModel.currentBetIndex -= 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }
}
